import React from 'react'
import { Link } from 'gatsby'
import slug from 'slug'
import styled from 'styled-components'

export const Wrapper = styled.div`
  margin-bottom: var(--spacing-3);
  margin-left: calc(var(--spacing-1) * -1);
  line-height: 1.25;
`

const Prefix = styled.span`
  opacity: 0.5;
`

const Tag = styled(Link)`
  white-space: nowrap;
  color: var(--tag-color);
  padding: var(--spacing-1);
  margin-right: var(--spacing-1);
  font-size: var(--fontSize-0);
  text-decoration: none;
  &:hover {
    color: var(--tag-color-hover);
  }
`

export const PostTags = ({ tags }) => {
  return (
    <Wrapper>
      {tags.map((name) => (
        <Tag key={name} to={`/tags/${slug(name)}`}>
          <Prefix>#</Prefix>
          {name}
        </Tag>
      ))}
    </Wrapper>
  )
}
